/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Kevin Vora's Portfolio",
  description:
    " I am a Ph.D. student working in the Cooperative Robotic Systems (CRS) lab under the guidance of Dr. Yu Tony Zhang at Arizona State University, Tempe, USA. My research focuses on generating explanations for reinforcement learning which can contribute to safety and ethics in AI.",
  og: {
    title: "Kevin Vora Portfolio",
    type: "website",
    url: "https://KevinTheBEST1.github.io",
  },
};

//Home Page
const greeting = {
  title: "Kevin Vora",
  logo_name: "Kevin Vora",
  //nickname:"KevinTheBEST1",
  subTitle:
    "I am a Ph.D. student working in the Cooperative Robotic Systems (CRS) lab under the guidance of Dr. Yu ''Tony'' Zhang at Arizona State University, Tempe, USA. My research focuses on generating explanations for reinforcement learning which can contribute to safety and ethics in AI.",
  resumeLink:"https://drive.google.com/file/d/1AVzbABNgeWfPPVf_lI2k45Ss4hNGYiim/view?usp=sharing",
  googleScholar:"https://scholar.google.com/citations?user=rCeJKCQAAAAJ&hl=fr"
};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/KevinTheBEST1",
  // linkedin: "https://www.linkedin.com/in/kevin-vora",
  // gmail: "kevinvora761@gmail.com",
  // facebook: "https://www.facebook.com/laymanbrother.19/",
  // instagram: "https://www.instagram.com/layman_brother/"

  {
    name: "Github",
    link: "https://github.com/KevinTheBEST1",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  // {
  //   name: "Google scholar",
  //   link: "https://scholar.google.com/citations?user=rCeJKCQAAAAJ&hl=fr",
  //   fontAwesomeIcon: "ai ai-google-scholar-square ai-3x",
  //   backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  // },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/kevin-vora",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "CRS Lab",
    link: "https://www.public.asu.edu/~yzhan442/CRS.html",
    fontAwesomeIcon: "fas fa-robot", // Reference https://fontawesome.com/icons/youtube?style=brands
    backgroundColor: "#00B0D8", // Reference https://simpleicons.org/?q=youtube
  },
  {
    name: "Gmail",
    link: "mailto:kevinvora761@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },

  {
    name: "Facebook",
    link: "https://www.facebook.com/kevin.vora.96/",
    fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
    backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/Best2711/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
];

const skills = {
  data: [
    {
      title: "Robotics & AI",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Simulating AI agent using planning and learning strategies " ,
        "⚡ Highly interested in Behavior-based robotics, XAI, and robot learning",
        "⚡ Experienced with various Robotics and AI tools like V-Rep and ROS. Also worked with PDDL, Reinforcement Learning(Q-learning, DDQN, Actor-Critic architecture), etc.",
      ],
      softwareSkills: [
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "Unity",
          fontAwesomeClassname: "bx:bxl-unity",
          style: {
            backgroundColor: "transparent",
            color: "##000000",
          },
        },
        {
          skillName: "Matlab",
          fontAwesomeClassname: "vscode-icons:file-type-matlab",
          style: {
            backgroundColor: "transparent",
          }
        },
        {
          skillName: "Numpy",
          fontAwesomeClassname: "logos:numpy",
          style: {
            backgroundColor: "transparent",
          }
        },
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        
        
      ],
    },

    {
      title: "Machine Learning",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Developing highly scalable production ready models for various deep-learning and machine-learning",
        "⚡ Experience with a wide modality of data including Natural Language, Image, Speech, Timeseries, EEG, etc",
        "⚡ Delivered solutions for use-cases like Robot Learning, Emotion Recognition, Keyword Extraction, Web-scraping, Recommendation Systems, Biometric verification, Object detection, and others",
      ],
      softwareSkills: [
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:keras",
          style: {
            backgroundColor: "white",
            color: "#D00000",
          },
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos-pytorch",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "R Programming",
          fontAwesomeClassname: "mdi:language-r",
          style: {
            backgroundColor: "transparent",
            color: "#276DC3",
          }
        },
        {
          skillName: "Matlab",
          fontAwesomeClassname: "vscode-icons:file-type-matlab",
          style: {
            backgroundColor: "transparent",
          }
        },
      ],
    },
  ], 
    
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/kevinthebest",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Arizona State University, Tempe, Az",
      subtitle: "PhD in Computer Science",
      logo_path: "arizona.png",
      alt_name: "ASU",
      duration: "2021 - Present",
      descriptions: [
        "⚡ Innovating ideas for Safe, Ethical, and Explainable AI.",
        "⚡ Contributing to areas like behavior-based robotics and XAI.",
        "⚡ Publish in top-tier journals and conferences like ICRA, AAAI, and others.",
      ],
      website_link: "https://webapp4.asu.edu/programs/t5/majorinfo/ASU00/ESCOMSCPHD/graduate/false?init=false&nopassive=true",
    },
    {
      title: "Arizona State University, Tempe, Az",
      subtitle: "MS in Robotics & Autonomous Systems",
      logo_path: "arizona.png",
      alt_name: "ASU",
      duration: "2019 - 2021",
      descriptions: [
        "⚡ Studied subjects like Advances in Robot Learning, Bio-Inspired AI and optimization, Artificial Intelligence, Artificial Neural Computation, and others.",
        "⚡ Gained hands-on experience working on projects like Robotics for Library management, Robo-Sparky, Learning simple behaviors from complex ones, and others.",
        "⚡ Mentored 150+ undergrad students for their semester-end project as a volunteering tutor for ANC course.",
      ],
      website_link: "https://ras.engineering.asu.edu/",
    },
    {
      title: "Nirma University, Gandhinagar, Gujarat",
      subtitle: "Bachelor of Technology, Information Technology",
      logo_path: "Nirma_University_Logo-removebg-preview.png",
      alt_name: "ASU",
      duration: "2015 - 2019",
      descriptions: [
        "⚡ Studied subjects like Data Structures, Algorithms, DBMS, Operating Systems, Networks, Web Design, etc.",
        "⚡ Built Maze solver robot with PID control using Raspberry-pi and various IoT applications like remote bulb control using MQTT.",
        "⚡ Member of Speech research group and Cognitive Computing group at the university and lead a team of 4 to carry out groundbreaking research.",
      ],
      website_link: "https://nirmauni.ac.in/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Machine Learning",
      subtitle: "- Kirill Eremenko",
      logo_path: "udemy-removebg-preview.png",
      certificate_link:
        "https://www.udemy.com/course/machinelearning/",
      alt_name: "Udemy",
      color_code: "#8C151599",
    },
    {
      title: "Sixth Sense Robotics",
      subtitle: "- SkyFi Labs",
      logo_path: "skyfilabs-logo-v1-removebg-preview.png",
      certificate_link:
        "https://www.skyfilabs.com/workshops/sixth-sense-robotics",
      alt_name: "robotics",
      color_code: "#00000099",
    },
    
    {
      title: "Introduction to Big Data with Spark and Hadoop",
      subtitle: "- Karthik Muthuraman",
      logo_path: "ibm_logo.png",
      certificate_link:
        "https://www.coursera.org/accounhttps://www.coursera.org/learn/introduction-to-big-data-with-spark-hadoopt/accomplishments/verify/BH2T9BRU87BH",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
   
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work and Internship",
  description:
    "Based on my professional experiences, I have realized the importance of research and development, timely deliverables, and ethics.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      experiences: [
        {
          title: "Graduate Research Assistant",
          company: "Knowledge Exchange for Resilience (KER)",
          company_url: "https://resilience.asu.edu/",
          logo_path: "arizona.png",
          duration: "Aug 2021 - PRESENT",
          location: "Arizona, USA",
          description:
            "Conduct Responsive Research by analysing housing, heat, census, and many other datasets. Develop pipeline for data collection, data pre-processing and data analytics for interactive dashboards.",
          color: "#0879bf",
        },
        {
          title: "Research AIDE (Data Analytics)",
          company: "Knowledge Exchange for Resilience (KER)",
          company_url: "https://resilience.asu.edu/",
          logo_path: "arizona-removebg-preview.png",
          duration: "Mar 2020 - Aug 2021",
          location: "Arizona, USA",
          description:
            "Performing data analytics related research for projects funded by NSF rapid grant and a few others. Developing semantic search platform for Non-Profit org and ASU researchers using contextual word embeddings.",
          color: "#0879bf",
        },
        
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "Research Intern",
          company: "IIT Gandhinagar",
          company_url: "https://iitgn.ac.in/",
          logo_path: "IIT-removebg-preview.png",
          duration: "May 2018 - Jul 2018",
          location: "Gandhinagar, India",
          description:
            "Developed creative virtual reality games for intelligent stroke rehabilitation of patients. Created regression model for polhemus fastrak and cyber glove to interact with virtual gaming environment. Communicated with the guide and research team to improve the system through their feedback and managed to build an Intelligent system that helps in hand rehabilitation.",
          color: "#fc1f20",
        },  
      ],
    },  
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My best experience is to create Robot learning, Data Science, machine learning and deep learning projects.",
  avatar_image_path: "projects_image.svg",



};

const publicationsHeader = {
  title: "Publications",
  description:
    "",
    
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "KevinVora1.png",
    description:
      "I am available via E-Mail and will get back to you as soon as possible. I would like to contribute to research in Robot learning (Planning and learning in AI) and Machine learning.",
  },
  addressSection: {
    title: "Address",
    subtitle:
      "Tempe, Az, USA",
    avatar_image_path: "address_image.svg",
  },
  phoneSection: {
    title: "Phone Number",
    subtitle: "+1-480-669-2021",
  },
  blogSection: {
    title: "CRS Lab",
    subtitle:
      "I'm recentally working for Cooperative Robotic Systems (CRS) Lab at ASU",
    link: "https://www.public.asu.edu/~yzhan442/CRS.html",
    avatar_image_path: "blogs_image.svg",
  },
  
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  contactPageData,
};
